import type { PayloadAction } from "@reduxjs/toolkit";
import { MotionMode, MotionObject } from "Data/Objects/Camera";
import { createAppSlice } from "Data/Redux/Store";
import type { MotionCameraState } from "Interfaces";
import { constant, times } from "lodash";

const initialState: MotionCameraState = {
	bikeConfidenceLevel: 0,
	daySensitivityLevel: 0,
	motionMode: MotionMode.VIDEO,
	nightSensitivityLevel: 0,
	personConfidenceLevel: 0,
	selectedMotionObjects: [ MotionObject.PERSON ],
	vehicleConfidenceLevel: 0,
	zones: times(8, (constant(null)))
};

// #region reducers

export const setMotionSettingsReducer = (state: MotionCameraState, action: PayloadAction<MotionCameraState>) => {
	if (!action.payload) {
		return;
	}

	return action.payload;
};

// #endregion

// #region Selectors

const getMotionSettings = (state: MotionCameraState) => {
	return state;
};

// #endregion

const motionSlice = createAppSlice({
	name: "motion",
	initialState,
	reducers: {
		setMotionSettingsAction: setMotionSettingsReducer
	},
	selectors: {
		selectMotionSettings: getMotionSettings
	}
});

export default motionSlice;

export const { setMotionSettingsAction } = motionSlice.actions;
export const { selectMotionSettings } = motionSlice.selectors;
